
import axios from "axios";
import { useContext } from "react";
import AppContext from "../Provider/AppContext";
import useHandleError from "./useHandleError";
import { getDecryptedData } from "../Util/store";

// const baseUrl = "https://www.fleetapi.exhibitsolutions.co.ke";
  const baseUrl = "https://abbebehauliers.fleetapi.exhibitsolutions.co.tz";

  // const baseUrl= "http://localhost:8000";

// const baseUrl="http://192.168.100.9:8000";


function useAxios() {
  const handleError = useHandleError();
  const { loadingModal, requestSuccessModal } = useContext(AppContext);
  const token = getDecryptedData("token");

  const request = async ({
    method = "GET",
    url = "",
    headers = {},
    body = {},
    params = {},
    custom_token = null,
    show_error = true,
    show_loading = true,
    loadingFunc = null,
    send_token = true,
    responseType = "json",
    prolongTimeout = 500,
    show_success = true,
  } = {}) => {
    if (!method || !url) {
      handleError({ custom: true, message: "Method and URL are required" });
      return "error";
    }

    if (show_loading) loadingModal?.loading();
    if (typeof loadingFunc === "function") loadingFunc(true);

    try {
      const config = {
        method,
        url: url.startsWith('http') ? url : `${baseUrl}${url.startsWith('/') ? url : '/' + url}`,
        headers: {
          ...(send_token && {
            Authorization: `Bearer ${custom_token || token}`,
          }),
          ...headers,
        },
        data: body,
        params,
        responseType,
      };

      const res = await axios(config);

      if (show_success && res?.data?.server_message) {
        requestSuccessModal?.handleShow({
          header: "Success",
          message: res.data.server_message,
        });
      }

      return res.data;
    } catch (error) {
      if (show_error) handleError(error);
      return "error";
    } finally {
      const hideLoading = () => {
        if (typeof loadingFunc === "function") loadingFunc(false);
        if (show_loading) loadingModal?.hide();
      };

      if (prolongTimeout) {
        setTimeout(hideLoading, prolongTimeout);
      } else {
        hideLoading();
      }
    }
  };

  return request;




}

export default useAxios;
